import { render } from "./Send.vue?vue&type=template&id=3ce19b1f&scoped=true"
import script from "./Send.vue?vue&type=script&lang=js"
export * from "./Send.vue?vue&type=script&lang=js"

import "./Send.vue?vue&type=style&index=0&id=3ce19b1f&scoped=true&lang=css"

import exportComponent from "/home/mugonat-caaz-omnibox/htdocs/caaz-omnibox.mugonat.com/releases/21/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ce19b1f"]])

export default __exports__